import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9684d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { style: {"font-size":"15px"} }
const _hoisted_4 = ["checked"]
const _hoisted_5 = { style: {"margin-right":"10px","margin-left":"1%"} }
const _hoisted_6 = ["checked"]
const _hoisted_7 = { style: {"margin-right":"10px","margin-left":"1%"} }
const _hoisted_8 = ["checked"]
const _hoisted_9 = { style: {"margin-right":"10px","margin-left":"1%"} }
const _hoisted_10 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { for: "medical" }
const _hoisted_13 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_14 = { for: "medical" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_16 = ["value", "disabled", "selected"]
const _hoisted_17 = {
  value: "nuovoCpp",
  selected: ""
}
const _hoisted_18 = {
  key: 0,
  class: "text-red-500 mb-2 w-full"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 1,
  for: "medical"
}
const _hoisted_21 = {
  key: 3,
  class: "text-red-500 mb-2 w-full"
}
const _hoisted_22 = { for: "confidenzialita" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "flex justify-between" }

import { Diagnosi, DiagnosiDetails } from "@/../../EshJSLib/models/patient";
import { onMounted, ref } from "vue";
import { patientStore } from "../../store/patient";
import { storeToRefs } from "pinia";
import 'vue-i18n';
import { Modal, Input } from "flowbite-vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'modal_add',
  setup(__props, { expose: __expose }) {

const store = patientStore();
const { patient } = storeToRefs(store);
const errors = ref([]);
const mandatoryFields = ['tipo_diagnosi', 'diagnosi_patologia', ['diagnosiDetails', 'careprovider']];


let loading = ref(false);
let altroMedico = ref('');
let medico = ref('');

const picked = ref('One')

const alertConfirmMessage = ref<null | string>(null);
const modalType = ref<"confirm" | "alert">("confirm");
const showConfirm = ref(false);
const altro = ref(false);
let row = ref({} as Diagnosi);


onMounted(() => {
     row.value.diagnosiDetails = {} as DiagnosiDetails
});


let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;

function openModal(message: string, alertModal: boolean, newRow: Diagnosi) {
    row.value = newRow;
    alertConfirmMessage.value = message;
    alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
    showConfirm.value = true;

    return new Promise((resolve) => {
        resolvePromise = resolve;
    });

}
function handleUserInput(value: boolean) {
    if(value) { if(!validateFields()) { return false; } }
    if (!resolvePromise) return;
    resolvePromise(value);
    showConfirm.value = false;
}

function assignName(value: string) {
    row.value.tipo_diagnosi = value;
}

function forNuovo() {
    if(row.value.diagnosiDetails.careprovider == 'nuovoCpp') {
        row.value.diagnosiDetails.careprovider = '';
        altro.value = true;
    } else {
        altro.value = false;
    }
}

function validateFields(): boolean {
  let hasError = false;
  errors.value = [];
  console.log(mandatoryFields);
 
  mandatoryFields.forEach((field, index) => {
    let value = null;
    if(typeof field != 'string') {
        value = row.value[field[0]][field[1]];
    }  else {
        value = row.value[field];
    }
    console.log(value);
    if (!value) {
            console.log(field);
            console.log(errors);
            hasError = true;
            
            errors.value.push("Questo campo è obbligatorio!");
            }
        else {
        errors.value.push("");

    }

  });

  if (hasError) {
    return false;
  }
  return true;
}

__expose({ openModal });



return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "2xl",
        onClose: _cache[10] || (_cache[10] = ($event: any) => (handleUserInput(false)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiungi nuova diagnosi')), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Tipologia *")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  id: "diagnosiRadio",
                  type: "radio",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (assignName('Diagnosi'))),
                  checked: _unref(row).tipo_diagnosi == 'Diagnosi'
                }, null, 40, _hoisted_4),
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Diagnosi")), 1),
                _createElementVNode("input", {
                  id: "allergiaRadio",
                  type: "radio",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (assignName('Allergia'))),
                  checked: _unref(row).tipo_diagnosi == 'Allergia'
                }, null, 40, _hoisted_6),
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Allergia")), 1),
                _createElementVNode("input", {
                  id: "intolleranzaRadio",
                  type: "radio",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (assignName('Intolleranza'))),
                  checked: _unref(row).tipo_diagnosi == 'Intolleranza'
                }, null, 40, _hoisted_8),
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Intolleranza")), 1)
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(errors.value[0]), 1)
            ]),
            _hoisted_11,
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Diagnosi *")), 1),
            _createVNode(_unref(Input), {
              id: "diagnosiType",
              class: "mb-2",
              placeholder: _ctx.$t('Inserisci la diagnosi'),
              modelValue: _unref(row).diagnosi_patologia,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(row).diagnosi_patologia) = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            _createElementVNode("p", _hoisted_13, _toDisplayString(errors.value[1]), 1),
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("Medico *")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(row).diagnosiDetails.careprovider) = $event)),
              id: "medical",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (forNuovo())),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).associated_doctors, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: item.care_provider?.fullname,
                  disabled: item.care_provider?.fullname === _unref(patient).user.utente_nome ? true : false
                        ,
                  selected: item.care_provider?.fullname === _unref(patient).user.utente_nome
                }, _toDisplayString(item.care_provider?.fullname), 9, _hoisted_16))
              }), 128)),
              _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t("Nuovo Careprovider..")), 1)
            ], 544), [
              [_vModelSelect, _unref(row).diagnosiDetails.careprovider]
            ]),
            (!altro.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.value[2]), 1))
              : _createCommentVNode("", true),
            _hoisted_19,
            (altro.value)
              ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t("Altro Medico")), 1))
              : _createCommentVNode("", true),
            (altro.value)
              ? (_openBlock(), _createBlock(_unref(Input), {
                  key: 2,
                  class: "mb-2",
                  modelValue: _unref(row).diagnosiDetails.careprovider,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(row).diagnosiDetails.careprovider) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (altro.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(errors.value[2]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "confidenzialita",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(row).id_livello_confidenzialita) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.id_livello_confidenzialita,
                  key: key
                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_23))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(row).id_livello_confidenzialita]
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (handleUserInput(false))),
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t("Annulla")), 1),
            _createElementVNode("button", {
              id: "submitDiagnosti",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (handleUserInput(true))),
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t("Salva")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})